import { render, staticRenderFns } from "./NotifyPatients.vue?vue&type=template&id=1b68602e&"
import script from "./NotifyPatients.vue?vue&type=script&lang=js&"
export * from "./NotifyPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports